module.exports = __webpack_public_path__ + "img/云广播系统.7a6ae05e.png";